import { FC } from 'react';

import { ICON_STROKE_WIDTH } from 'views/components/UI/Icons/icons.constants';
import { IIconProps } from 'views/components/UI/Icons/icons.interface';

const PriorityMajor: FC<IIconProps> = ({
  size = '16',
  color = 'var(--sk-icon-warning)',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 10.1614L9.01015 6.17159C8.45226 5.6137 7.54774 5.6137 6.98985 6.17159L3 10.1614"
      stroke={color}
      strokeWidth={ICON_STROKE_WIDTH}
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);

export { PriorityMajor };
